import { render, staticRenderFns } from "./ImplantacaoDialCampaign.vue?vue&type=template&id=36725cd4&scoped=true"
import script from "./ImplantacaoDialCampaign.vue?vue&type=script&lang=js"
export * from "./ImplantacaoDialCampaign.vue?vue&type=script&lang=js"
import style0 from "./ImplantacaoDialCampaign.vue?vue&type=style&index=0&id=36725cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36725cd4",
  null
  
)

export default component.exports